export const initGoogleTagManager = (id, cookieBotId) => {
  if (!id || document.getElementById("init-gtm-script")) {
    return
  }

  ;(function (w, d, s, l, i, cookieBotId) {
    w[l] = w[l] || []
    w[l].push({ cookieBotId: cookieBotId || null })
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" })
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : ""
    j.async = true
    j.id = "init-gtm-script"
    j.src = "https://cenltpvw.eur.stape.net/gtm.js?id=" + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, "script", "dataLayer", id, cookieBotId)
}
